import { Button, Checkbox, Typography } from '@fullscreendigital/carrefour-dex-fe'
import { Box, Container, Grid, Paper } from '@mui/material'
import { getInProgressReports } from 'components/shop-reception/mobile/api'
import { TitleHeader } from 'components/shop-reception/mobile/Common/TitleHeader'
import { useNotification } from 'hooks'
import { useMemo, useState } from 'react'
import s from './ReportProcessing.modules.scss'
import { useMutation } from 'react-query'
import { makeCorePostRequest } from 'utils/api'
import { toReportsPayload } from './serializers'
import { useNavigate } from 'react-router-dom'
import { formatErrorMessage } from 'utils/formatting'
import { ReturoReport } from 'components/shop-reception/mobile/interfaces'
import { getShopReceptionShops } from 'components/Layout/api'
import { getReturoId } from 'components/shop-reception/mobile/helpers'

const ReportProcessing = () => {
  const [selectedReports, setSelectedReports] = useState<ReturoReport[]>([])

  const { showNotification } = useNotification()

  const navigate = useNavigate()

  const { data: reports, isLoading } = getInProgressReports(showNotification, setSelectedReports)

  const toggleReport = (report: ReturoReport) => {
    if (selectedReports.some(item => item.id === report.id)) {
      setSelectedReports(selectedReports.filter(item => item.id !== report.id))
    } else {
      setSelectedReports([...selectedReports, report])
    }
  }

  const saveReports = async (values: { id: number[] }) =>
    await makeCorePostRequest('/shop-reception-mobile/returo/notices/deliver', values)

  const { mutate } = useMutation(saveReports, {
    onSuccess: () => {
      showNotification({
        message: 'PV-urile au fost predate cu succes.',
        type: 'success'
      })
      navigate('/returo')
    },
    onError: res => {
      showNotification({
        message: `A aparut o eroare la predarea proceselor verbale. ${formatErrorMessage(res)}`,
        type: 'error'
      })
    }
  })

  const submitReports = () => {
    mutate(toReportsPayload(selectedReports))
  }

  const { data: shops } = getShopReceptionShops(showNotification, true)

  const idReturo = useMemo(() => getReturoId(shops), [shops])

  return (
    <Container maxWidth="xs" style={{ marginTop: '20px' }}>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <TitleHeader title={`ID Returo: ${idReturo}`} />
        </Grid>
        {reports?.length ? (
          <>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                {reports?.map((item: ReturoReport) => (
                  <Grid item xs={12} key={item.id}>
                    <Paper
                      elevation={3}
                      className={s.reportContainer}
                      onClick={() => toggleReport(item)}
                    >
                      <Typography variant="medium" component="p">
                        <Checkbox
                          checked={selectedReports?.some(report => report.id === item.id)}
                          onChange={() => {
                            toggleReport(item)
                          }}
                        />
                      </Typography>
                      <Box>
                        <Typography variant="medium" component="p">
                          {item.noticeNumber} {item.cmrNumber}
                        </Typography>
                        <Typography variant="medium" component="p">
                          {item.truckNumber} {item.driverName}
                        </Typography>
                        <Typography variant="medium" component="p">
                          {item.createdBy}
                        </Typography>
                        <Typography variant="medium" component="p">
                          {item.created}
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </Grid>
            <Grid xs={12} item>
              <Button
                type="submit"
                variant="contained"
                label="Predă PV-urile"
                style={{ width: '100%' }}
                onClick={submitReports}
              />
            </Grid>
          </>
        ) : !isLoading ? (
          <Grid item xs={12}>
            Nu există PV-uri în predare.
          </Grid>
        ) : null}
      </Grid>
    </Container>
  )
}

export default ReportProcessing
